/**
 * DocSidebar Component
 *
 * Public wrapper that delegates to DocSidebarLive implementation.
 * This thin wrapper maintains a stable import path for all consumers.
 */

import { DocSidebarLive, type DocSidebarProps } from "./DocSidebarLive";

export function DocSidebar(props: DocSidebarProps) {
  return <DocSidebarLive {...props} />;
}

export type { DocSidebarProps } from "./DocSidebarLive";
